import { TableContainer, Table as SanlamTable } from '@sanlam-glacier/app-common/components';
import { PropsWithChildren } from 'react';

interface TableProps {
  className?: string;
}

export const Table = ({ children, className }: PropsWithChildren<TableProps>) => {
  return (
    <>
      <TableContainer className={className}>
        <SanlamTable>{children}</SanlamTable>
      </TableContainer>
    </>
  );
};
